import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Container } from "./Container";

/** Accessible visual breadcrumb trail. items: [{ name, to }] (last item = current, no `to`). */
export function Breadcrumbs({ items, className = "" }) {
  return (
    <nav aria-label="Breadcrumb" className={`pt-24 md:pt-28 ${className}`} data-testid="breadcrumbs">
      <Container>
        <ol className="flex flex-wrap items-center gap-2 text-sm text-black/45">
          {items.map((it, i) => (
            <li key={i} className="flex items-center gap-2">
              {it.to ? (
                <Link to={it.to} className="transition-colors duration-200 hover:text-black">
                  {it.name}
                </Link>
              ) : (
                <span className="font-medium text-black/70" aria-current="page">{it.name}</span>
              )}
              {i < items.length - 1 && <ChevronRight className="h-3.5 w-3.5 text-black/25" strokeWidth={2} />}
            </li>
          ))}
        </ol>
      </Container>
    </nav>
  );
}
